import React from 'react';

import ForkAwesomeIcon from '@/components/fork-awesome-icon';
import List, { ListItem } from '@/components/list';
import Widget from '@/components/ui/widget';
import { useFrontendConfig } from '@/hooks/use-frontend-config';
import { useMinWidth } from '@/hooks/use-min-width';
import { useInstance } from '@/stores/instance';
import { useSettings } from '@/stores/settings';

import { breakpoints } from '../ui/layout';

const PromoPanel: React.FC = () => {
  const instance = useInstance();
  const { promoPanel } = useFrontendConfig();
  const { locale, sidebarItems } = useSettings();
  const isAsideDisplayed = useMinWidth(`(min-width: ${breakpoints.lg})`);

  const promoItems = promoPanel.items;

  if (!promoItems || !promoItems.length) return null;

  return (
    <Widget
      className='promo-panel'
      title={sidebarItems.includes('title') && isAsideDisplayed ? undefined : instance.title}
    >
      <List>
        {promoItems.map((item, i) => (
          <ListItem
            className='promo-panel__link'
            key={i}
            href={item.url}
            label={
              <div className='promo-panel__item'>
                <ForkAwesomeIcon id={item.icon} fixedWidth />
                <span>{item.textLocales[locale] || item.text}</span>
              </div>
            }
            size='sm'
          />
        ))}
      </List>
    </Widget>
  );
};

export { PromoPanel as default };
